import { styled } from "@mui/material";
import GenericModal from "../../../../../../../../components/Generic/Modal";

export const Modal = styled(GenericModal)(() => ({
  maxWidth: "610px",
}));
